import React from 'react';

export const ModuleWide = (props) => (
    <div className="content wide" id={props.id}>
        {props.content}
    </div>
);
